export default __webpack_public_path__ + "af0822f560efc8ce43f8fd470245d98d.webp";